<div class="om-phone-shell">
  <ngx-intl-tel-input
    [preferredCountries]="preferredCountries"
    [searchCountryField]="searchCountryFields"
    [enableAutoCountrySelect]="true"
    [searchCountryFlag]="true"
    [selectFirstCountry]="true"
    [selectedCountryISO]="selectedCountryISO()"
    [phoneValidation]="false"
    [separateDialCode]="true"
    [enablePlaceholder]="true"
    [customPlaceholder]="placeholder()"
    [inputId]="inputId()"
    [formControl]="phoneCtrl"
    [cssClass]="'om-phone-control'"
    (countryChange)="onCountryChanged($event)"
  />
</div>
